/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminAuditLogSub } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminAuditLogsResponse } from '../models';
// @ts-ignore
import type { GetAuditLogEntityTypesResponse } from '../models';
/**
 * AuditLogApiApi - axios parameter creator
 */
export const AuditLogApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} auditLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogDetails: async (auditLogId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditLogId' is not null or undefined
            assertParamExists('auditLogApiGetAdminAuditLogDetails', 'auditLogId', auditLogId)
            const localVarPath = `/admin/audit-logs/{audit_log_id}`
                .replace('{audit_log_id}', encodeURIComponent(String(auditLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogEntityTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/audit-logs/entity-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [action] 
         * @param {string} [actorUserId] 
         * @param {boolean} [changesOnly] 
         * @param {string} [entityType] 
         * @param {string} [maxDate] 
         * @param {string} [method] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogs: async (action?: string, actorUserId?: string, changesOnly?: boolean, entityType?: string, maxDate?: string, method?: string, minDate?: string, pageNo?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (actorUserId !== undefined) {
                localVarQueryParameter['actor_user_id'] = actorUserId;
            }

            if (changesOnly !== undefined) {
                localVarQueryParameter['changes_only'] = changesOnly;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogApiApi - functional programming interface
 */
export const AuditLogApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditLogApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} auditLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogApiGetAdminAuditLogDetails(auditLogId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAuditLogSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogApiGetAdminAuditLogDetails(auditLogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogApiApi.auditLogApiGetAdminAuditLogDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogApiGetAdminAuditLogEntityTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuditLogEntityTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogApiGetAdminAuditLogEntityTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogApiApi.auditLogApiGetAdminAuditLogEntityTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [action] 
         * @param {string} [actorUserId] 
         * @param {boolean} [changesOnly] 
         * @param {string} [entityType] 
         * @param {string} [maxDate] 
         * @param {string} [method] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditLogApiGetAdminAuditLogs(action?: string, actorUserId?: string, changesOnly?: boolean, entityType?: string, maxDate?: string, method?: string, minDate?: string, pageNo?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminAuditLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditLogApiGetAdminAuditLogs(action, actorUserId, changesOnly, entityType, maxDate, method, minDate, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditLogApiApi.auditLogApiGetAdminAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditLogApiApi - factory interface
 */
export const AuditLogApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditLogApiApiFp(configuration)
    return {
        /**
         * 
         * @param {AuditLogApiApiAuditLogApiGetAdminAuditLogDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogDetails(requestParameters: AuditLogApiApiAuditLogApiGetAdminAuditLogDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAuditLogSub> {
            return localVarFp.auditLogApiGetAdminAuditLogDetails(requestParameters.auditLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogEntityTypes(options?: RawAxiosRequestConfig): AxiosPromise<GetAuditLogEntityTypesResponse> {
            return localVarFp.auditLogApiGetAdminAuditLogEntityTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditLogApiApiAuditLogApiGetAdminAuditLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogApiGetAdminAuditLogs(requestParameters: AuditLogApiApiAuditLogApiGetAdminAuditLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminAuditLogsResponse> {
            return localVarFp.auditLogApiGetAdminAuditLogs(requestParameters.action, requestParameters.actorUserId, requestParameters.changesOnly, requestParameters.entityType, requestParameters.maxDate, requestParameters.method, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for auditLogApiGetAdminAuditLogDetails operation in AuditLogApiApi.
 */
export interface AuditLogApiApiAuditLogApiGetAdminAuditLogDetailsRequest {
    readonly auditLogId: string
}

/**
 * Request parameters for auditLogApiGetAdminAuditLogs operation in AuditLogApiApi.
 */
export interface AuditLogApiApiAuditLogApiGetAdminAuditLogsRequest {
    readonly action?: string

    readonly actorUserId?: string

    readonly changesOnly?: boolean

    readonly entityType?: string

    readonly maxDate?: string

    readonly method?: string

    readonly minDate?: string

    readonly pageNo?: number

    readonly pageSize?: number
}

/**
 * AuditLogApiApi - object-oriented interface
 */
export class AuditLogApiApi extends BaseAPI {
    /**
     * 
     * @param {AuditLogApiApiAuditLogApiGetAdminAuditLogDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public auditLogApiGetAdminAuditLogDetails(requestParameters: AuditLogApiApiAuditLogApiGetAdminAuditLogDetailsRequest, options?: RawAxiosRequestConfig) {
        return AuditLogApiApiFp(this.configuration).auditLogApiGetAdminAuditLogDetails(requestParameters.auditLogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public auditLogApiGetAdminAuditLogEntityTypes(options?: RawAxiosRequestConfig) {
        return AuditLogApiApiFp(this.configuration).auditLogApiGetAdminAuditLogEntityTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditLogApiApiAuditLogApiGetAdminAuditLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public auditLogApiGetAdminAuditLogs(requestParameters: AuditLogApiApiAuditLogApiGetAdminAuditLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditLogApiApiFp(this.configuration).auditLogApiGetAdminAuditLogs(requestParameters.action, requestParameters.actorUserId, requestParameters.changesOnly, requestParameters.entityType, requestParameters.maxDate, requestParameters.method, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

